import { Api, HorizontalAlignment, McLeodClassicIntegration, Navigation, StringUtil } from "@mcleod/core";
import { Button, ButtonVariant, Component, DataSourceMode, Label, Panel, Snackbar } from "@mcleod/components";
import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { AutogenLayoutBrokerageStatusCode } from "./autogen/AutogenLayoutBrokerageStatusCode";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

export class BrokerageStatusCode extends AutogenLayoutBrokerageStatusCode {
    buttonOpenClassic: any;

    override onLoad() {
        this.validateStatusCodeRecordExist();
    }

    validateStatusCodeRecordExist() {
        const workflowProfileUrl = "lme/powerbroker/BrokerageStatusCode?mode=update&key=";
        const validateProps: DuplicateIdProps = {tableName: "brokerage_status", screenName: "BrokerageStatusCode", navigateToUrl: workflowProfileUrl};
        DuplicateId.configureIdTextbox(this.textStatusID, validateProps);
    }

    buttonOpenClassicOnClick() {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.dsp.EntryBrokerageStatus", this.mainDataSource.activeRow.get("id"));
    }

    sourceBrokerageStatusCodeAfterExecution(event) {
        event.filter.parent_row_id = this.mainDataSource?.activeRow?.get("id");
        this.panelColorDisplay.backgroundColor = this.mainDataSource?.activeRow?.get("planning_hex_color");
        this.panelColorDisplay.tooltip = this.mainDataSource?.activeRow?.get("planning_hex_color");
        this.titleEditModeSuffix = this.mainDataSource?.activeRow?.get("descr");
    }

    sourceBrokerageStatusCodeBeforeModeChange(event) {
        this.buttonOpenClassic.visible = event.newMode === DataSourceMode.UPDATE;

        if (event.newMode === DataSourceMode.ADD) {
            this.textStatusID.enabledDuringAdd = true;
        }

        if (event.newMode === DataSourceMode.UPDATE) {
            this.textStatusID.required = true;
        }
    }

    buttonClearColorOnClick() {
        this.syncPlanningColor({});
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForNumericColor();
        if (result?.hexColor && result?.numericColor) {
            this.syncPlanningColor(result);
        }
    }

    private syncPlanningColor(result: SelectedColor = {}) {
        const { colorName, hexColor, numericColor } = result;
        this.sourceBrokerageStatus.activeRow.set("planning_hex_color", hexColor);
        this.sourceBrokerageStatus.activeRow.set("planning_color", numericColor);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }
}
